import * as React from 'react';
import SecondaryMenu from '../shared/SecondaryMenu';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useForm, Controller } from "react-hook-form";
import api from '../../store/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/Info';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';

interface Reason {
    reasonId?: string | null,
    name: string | null,
    deleted: boolean | null,
    reasonForWaitTimeId?: string | null,
};

export const REASON_TYPE = {
    CALLOUT: 'CALLOUT',
    DELAY: 'DELAY',
    WAIT_TIME: 'WAIT_TIME',
    CANCELLATION: 'CANCELLATION',
}

const REASON_TYPE_VALUES = {
    [REASON_TYPE.CALLOUT]: {
        title: 'Reasons For Callout',
        description: 'For accuracy of reporting, favour adding Reasons For Callout over deleting them or changing their meaning.',
        getReasonsApiFunc: () => api.getReasonsForCalloutUser(''),
        addUpdateReasons: (reasons: Reason[]) => {         
            const _r = reasons.map((r: Reason) => {
                const _r = { ...r, reasonForCalloutId: r.reasonId }
                delete _r.reasonId
                return _r
            })
            return api.addUpdateReasonsForCallout('', { reasonsForCallout: _r })
        }
    },
    [REASON_TYPE.DELAY]: {
        title: 'Reasons For Delay',
        description: 'For accuracy of reporting, favour adding Reasons For Delay over deleting them or changing their meaning.',
        getReasonsApiFunc: () => api.getReasonsForDelayPerUser(''),
        addUpdateReasons: (reasons: Reason[]) => {
            const _r = reasons.map((r: Reason) => {
                const _r = { ...r, reasonForDelayId: r.reasonId }
                delete _r.reasonId
                return _r
            })
            return api.addupdateReasonsForDelay('', { reasonsForDelay: _r })
        }
    },
    [REASON_TYPE.CANCELLATION]: {
        title: 'Reasons For Cancel',
        description: 'For accuracy of reporting, favour adding Reasons For Cancel over deleting them or changing their meaning.',
        getReasonsApiFunc: () => api.getReasonsForCancellationPerUser(''),
        addUpdateReasons: (reasons: Reason[]) => {
            const _r = reasons.map((r: Reason) => {
                const _r = { ...r, reasonForCancellationId: r.reasonId }
                delete _r.reasonId
                return _r
            })
            return api.addupdateReasonsForCancellation('', { reasonsForCancellation: _r })
        }
    },     
    [REASON_TYPE.WAIT_TIME]: {
        title: 'Reasons For Wait Time',
        description: 'Reasons that a team has been kept waiting by a client during patient transport pickup.',
        getReasonsApiFunc: () => api.getReasonsForWaitTimeUser(''),
        addUpdateReasons: (reasons: Reason[]) => {
            const _r = reasons.map((r: Reason) => {
                const _r = { ...r, reasonForWaitTimeId: r.reasonId === undefined ? r.reasonForWaitTimeId : r.reasonId }
                delete _r.reasonId
                return _r
            })
            return api.addUpdateReasonsForWaitTime('', { reasonForWaitTime: _r })
        }
    },
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 40,
        flexGrow: 1,
    },
    textFieldLable: {
        fontSize: 15,
        color: '#949494',
        padding: theme.spacing(0, 0, 1, 0)
    },
    textFieldRoot: {
        width: '100%'
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '40px'
    },
    alertRoot: {
        marginTop: 24
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    formBtn: {
        margin: theme.spacing(0, 1, 0, 1),
        width: '100px',
        height: '40px'
    },
    formLeft: {
        paddingLeft: 40,
        paddingBottom: 40,
    },
    heading: {
        fontSize: 30,
        fontWeight: 'bold'
    },
    mainGrid: {
        width: '100%'
    },
}));

const CreateLoadingLine = (props: any): JSX.Element => {
    const classes = useStyles();
    return (
        <div className={classes.loading}>
            <LinearProgress color="primary" />
        </div>
    )
}

const AddIcon = (props: any) => {
    return (
        <SvgIcon style={{ height: 24, width: 24 }}>
            <defs>
                <clipPath id="clip-path">
                    <path id="Combined_Shape" data-name="Combined Shape" d="M3.222,18.778A11,11,0,1,1,18.778,3.222,11,11,0,1,1,3.222,18.778ZM2,11a9,9,0,1,0,9-9A9.01,9.01,0,0,0,2,11Zm8,4V12H7a1,1,0,1,1,0-2h3V7a1,1,0,1,1,2,0v3h3a1,1,0,0,1,0,2H12v3a1,1,0,0,1-2,0Z" transform="translate(0 0)" />
                </clipPath>
            </defs>
            <g id="Group_17" data-name="Group 17">
                <path id="Combined_Shape-2" data-name="Combined Shape" d="M3.222,18.778A11,11,0,1,1,18.778,3.222,11,11,0,1,1,3.222,18.778ZM2,11a9,9,0,1,0,9-9A9.01,9.01,0,0,0,2,11Zm8,4V12H7a1,1,0,1,1,0-2h3V7a1,1,0,1,1,2,0v3h3a1,1,0,0,1,0,2H12v3a1,1,0,0,1-2,0Z" transform="translate(0 0)" />
                <g id="Mask_Group_17" data-name="Mask Group 17" clipPath="url(#clip-path)">
                    <g id="COLOR_black" data-name="COLOR/ black">
                        <rect id="Rectangle" width="24" height="24" fill="#02489d" />
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
}

function AddEditReasonWidget(props: any): JSX.Element {
    //States and Variables
    const reason: Reason = {
        reasonId: null,
        name: '',
        deleted: null
    }
    const reasonType = props.reasonType ?? REASON_TYPE.DELAY
    const classes = useStyles();
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError, trigger } = useForm();
    const [mainHeadingText, setMainHeadingText] = useState(REASON_TYPE_VALUES[reasonType].title);
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [reasons, setReasons] = useState([reason]);

    //Functions and API calls
    React.useEffect(() => {
        getReasons();
    }, []);

    //Get reasons per user
    const getReasons = async (): Promise<void> => {
        setLoading(true);
        await REASON_TYPE_VALUES[reasonType].getReasonsApiFunc().then(_res => {
            if (_res.data !== null && _res.data.model !== null && !_res.data.errorRaised) {
                if (_res.data.model.length > 0) {
                    const resp = _res.data.model

                    setReasons(resp.map((r: any) => {
                        return {
                            reasonId: r.reasonForDelayId ?? r.reasonForCalloutId ?? r.reasonForWaitTimeId ?? r.reasonForCancellationId,
                            ...r,
                        }
                    }));
                    for (let reasonIndex = 0; reasonIndex < _res.data.model.length; reasonIndex++) {
                        setValue('reason' + reasonIndex, _res.data.model[reasonIndex].name);
                    }
                }
            }
            setLoading(false);
            resetMessages();
        }).catch(error => {
            resetMessages();
            setLoading(false);
        });
    }

    //Add or update reasons
    const AddUpdateReasons = async (): Promise<void> => {
        setLoading(true);

        setStatusMessage("");
        setErrorMessage("");

        let values = getValues();
        let _reasons = [...reasons];

        for (let reasonIndex = 0; reasonIndex < _reasons.length; reasonIndex++) {
            let _reasonTemp = _reasons[reasonIndex];
            if (!_reasonTemp.deleted)
                _reasonTemp.name = values['reason' + reasonIndex];
        }

        await REASON_TYPE_VALUES[reasonType].addUpdateReasons(_reasons)
            .then(res => {
                if (!res.hasError && res.message !== null) {
                    resetMessages();
                    setStatusMessage(res.message);                   
                    if (res.model != null && res.model.length > 0) {
                        setReasons(res.model.map((r: any) => {
                            return {
                                reasonId: r.reasonForDelayId ?? r.reasonForCalloutId ?? r.reasonForCancellationId  ,
                                ...r,
                            }
                        }));
                        for (let reasonIndex = 0; reasonIndex < res.model.length; reasonIndex++) {
                            setValue('reason' + reasonIndex, res.model[reasonIndex].name);
                        }
                    } else {
                        setReasons([reason]);
                    }
                }
                else {
                    resetMessages();
                    setErrorMessage(res.message ?? "");
                }
                setLoading(false);
            })
            .catch(error => {
                setErrorMessage(error);
                setLoading(false);
            });
    }

    //Reset messages
    const resetMessages = () => {
        setErrorMessage('');
        setStatusMessage('');
    }

    //Delete reason locally
    const deleteReason = (index: number) => {
        let reasonTemp = [...reasons];
        let reason = { ...reasonTemp[index] };
        if (reason.reasonId !== null) {
            reason.deleted = true;
            reasonTemp[index] = reason;
            setReasons([...reasonTemp]);
        } else {
            if (index > -1) {
                reasonTemp.splice(index, 1);
            }
            setReasons([...reasonTemp]);
        }
    }

    const appendReason = (newReason: any) => {
        setReasons(reasons.concat(newReason));
    }

    const addReason = () => {
        appendReason(reason);
    }

    return (
        <React.Fragment>

            <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>
                <div style={{ alignSelf: 'stretch', display: 'flex' }}>
                    <SecondaryMenu selectedmenu={REASON_TYPE_VALUES[reasonType].title} />
                </div>

                <form style={{ width: '100%' }} onSubmit={handleSubmit(AddUpdateReasons)} autoComplete="off" id="addCustomerForm">
                    <div style={{ width: '100%', height: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div className={classes.root}>

                            <Grid className={classes.mainGrid} container alignItems="flex-start" spacing={3}>
                                <Grid item xs={12}>
                                    <div className={classes.heading}>
                                        {mainHeadingText}
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div>
                                        {REASON_TYPE_VALUES[reasonType].description}
                                    </div>
                                </Grid>

                                <Grid container alignItems="flex-start" style={{ marginTop: 5, marginLeft: 10 }}>
                                    {reasons.map((reason, index) => {
                                        if (reason.deleted !== true) {
                                            return (
                                                <React.Fragment key={'reasonKeyFragment' + index}>
                                                    <Grid item xs={5} style={{ marginTop: 5 }}>
                                                        <Controller
                                                            control={control}
                                                            key={'reasonKey' + index}
                                                            as={<TextField value={reason.name}
                                                                key={'reasonKeyText' + index}
                                                                classes={{ root: classes.textFieldRoot }}
                                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                                variant='outlined'
                                                                error={errors['reason' + index]}
                                                                helperText={errors['reason' + index] ? errors['reason' + index].message : ""} />}
                                                            name={'reason' + index}
                                                            defaultValue=''
                                                            rules={{
                                                                required: "Reason is required",
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4} style={{ marginTop: 8, marginLeft: 10 }}>
                                                        <IconButton onClick={() => deleteReason(index)} style={{ height: 30, width: 30 }} aria-label="delete">
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </React.Fragment>
                                            )
                                        }
                                    })}
                                </Grid>

                                <Grid container style={{ marginLeft: 0, paddingLeft: 0 }} item xs={12} alignItems="flex-start">
                                    <Button
                                        color="default"
                                        onClick={addReason}
                                        style={{ margin: 0, padding: 0, color: '#0049A3', fontSize: 18 }}
                                        startIcon={<AddIcon />}>
                                        Add reason
                                    </Button>
                                </Grid>

                            </Grid>
                        </div>

                        <div>
                            <div style={{ paddingLeft: 40, paddingRight: 40, }}>
                                <div className={classes.headingAlert}>
                                    <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                        {errorMessage}
                                    </Alert>
                                    <Alert variant="filled" icon={<InfoIcon />} severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                                        {statusMessage}
                                    </Alert>
                                </div>
                            </div>

                            <div style={{ paddingTop: 20, paddingBottom: 20, }}>
                                {loading ? <CreateLoadingLine /> : null}
                            </div>

                            <div className={classes.formLeft} >
                                <Button disabled={formState.isSubmitting} className={classes.formBtn} variant="contained" color="primary" type='submit'>Save</Button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </React.Fragment>
    )
}

export default React.memo(AddEditReasonWidget);